import { DatesHelpers } from "@core/helpers";

export const IBillingAriaInvoice = Object.freeze({
  id: "id",
  number: "number",
  date: "date",
  amountTtc: "amount_ttc",
});

export class BillingAriaInvoiceModel {
  constructor(data = {}) {
    this[IBillingAriaInvoice.id] = data[IBillingAriaInvoice.id];
    this[IBillingAriaInvoice.number] = data[IBillingAriaInvoice.number];
    this[IBillingAriaInvoice.date] = data[IBillingAriaInvoice.date];
    this[IBillingAriaInvoice.amountTtc] = data[IBillingAriaInvoice.amountTtc];
  }

  getId() {
    return this[IBillingAriaInvoice.id];
  }

  getNumber() {
    return this[IBillingAriaInvoice.number];
  }

  getDate() {
    return DatesHelpers.getDayjs(this[IBillingAriaInvoice.date]);
  }

  getFormattedDate(format = "DD/MM/YYYY") {
    return this.getDate().format(format);
  }

  getAmount() {
    return this[IBillingAriaInvoice.amountTtc];
  }
}
